import { ca } from '@cian/analytics';
import { useUpdateEffect } from '@cian/react-utils';

import { useQueryClient } from '@tanstack/react-query';

import { useUserQuery } from '@/packages/query-state/shared/store/monolith-python/cian-api/site/v1/get-user-data-by-request/query';
import { getAnalyticsUser } from '@/packages/utils/analytics/getAnalyticsUser';

export function useUserUpdate(): void {
  const { data: user } = useUserQuery({ notifyOnChangeProps: ['data'] });

  const queryClient = useQueryClient();

  useUpdateEffect(() => {
    ca('user', getAnalyticsUser({ queryClient }));
  }, [user]);
}
